import Vue from "vue";

import ProductForm from "../ProductForm/ProductForm.vue";

export interface OpenDirectoryProductOptions {
  parent?: Vue;
  onClose?: () => void;
}

const DOCAPI_ID_RE = /^d:([^:]+):(\d+)$/;

export function parseDirectoryProductId(
  id: string | number | null | undefined
): string | number | null {
  if (id == null || id === "") {
    return null;
  }

  const raw = String(id).trim();

  if (DOCAPI_ID_RE.test(raw)) {
    return raw;
  }

  if (/^\d+$/.test(raw)) {
    const numeric = Number(raw);
    if (numeric > 0) {
      return `d:products:${numeric}`;
    }
  }

  return null;
}

export function buildDirectoryProductDocumentPreview(
  id: string | number | null | undefined
) {
  const parsed = parseDirectoryProductId(id);
  return parsed != null ? { id: parsed } : null;
}

export function openDirectoryProductModal(
  vm: Vue,
  id: string | number | null | undefined,
  options: OpenDirectoryProductOptions = {}
) {
  const documentPreview = buildDirectoryProductDocumentPreview(id);
  if (!documentPreview) {
    console.debug("[openDirectoryProduct.openDirectoryProductModal] SKIP", {
      id,
      reason: "unparseable id"
    });
    return null;
  }

  const parent = options.parent || vm;
  const onClose = options.onClose;

  console.debug("[openDirectoryProduct.openDirectoryProductModal] START", {
    id: documentPreview.id
  });

  let closed = false;
  const handleClose = () => {
    if (closed) {
      return;
    }
    closed = true;
    if (onClose) {
      onClose();
    }
  };

  const modal = vm.$buefy.modal.open({
    component: ProductForm,
    props: {
      isNew: false,
      documentPreview,
      initParams: {}
    },
    events: {
      "form-close": handleClose
    },
    hasModalCard: true,
    fullScreen: true,
    customClass: "document-form",
    parent,
    onCancel: handleClose
  });

  // `$parent.close()` on forms calls Modal.close(), which does not always
  // trigger onCancel — listen to close so URL resets after save too.
  if (modal && typeof (modal as any).$once === "function") {
    (modal as any).$once("close", handleClose);
  }

  return modal;
}
